export const ARIA_LABEL_NAMESPACE = 'AriaLabels';
export const ARIA_LABEL_KEY = 'dropDownMenu_AriaLabel_TopLevel_SiteNavigation';
export const ARIA_LABEL_DEFAULT = 'Site';
export const ARIA_LABELLED_BY_PREFIX = 'anchor-label_';
